import i18next, { t, exists as isTranslationExists } from 'i18next'
import { fetchDedics, createDedicsMarkup } from './dedicFuncs'
import { currencyStore } from '../../localization/currency'
import { createStore, renderMarkup } from '../../servicesCommonFns'
import rangeSlider from 'range-slider-input'
import { shevronIcon } from '../../icons'

const FILTER_ORDER = [
  { name: 'dc' },
  { name: 'gen' },
  {
    name: 'cpu',
    hasSubcategory: true,
    subcategoryOrder: ['cpumanuf', 'cpucores', 'cpuamount', 'cpu'],
  },
  {
    name: 'ram',
    hasSubcategory: true,
  },
  {
    name: 'drive',
    hasSubcategory: true,
  },
  { name: 'raid' },
  { name: 'traffic' },
  { name: 'rate' },
  {
    name: 'boolean',
    hasSubcategory: true,
    subcategoryOrder: [
      'booleanpromo',
      'booleannew',
      'booleanlarge',
      'booleannvme',
      'booleanperf',
      'booleanbest',
    ],
  },
]

const QUICK_ACTIVATION_CATEGORY = 'quick_activation'
const PRICE_CATEGORY = 'price'
const CONFIG_CATEGORY = 'config'

export const DEDIC_FILTER_RANGE_GROUPS = ['cpucores']

const container = document.querySelector('[data-tbody]')
const mobileContainer = document.querySelector('[data-dedic-list]')

/**  --------- STORE INITIALIZING ---------  */
const initialState = { dedicTariffsToRender: [], tariffs: [], filteredTariffs: [], dc: 'all' }

const store = createStore(initialState)
/**  --------- /STORE INITIALIZING ---------  */

/**  --------- FILTER INITIALIZING ---------  */
const header = document.getElementById('header')
const openFilterBtns = document.querySelectorAll('[data-dedic-filter-toggle]')
const clearFilterBtn = document.querySelector('[data-dedic-filter-clear]')
const filteredActions = document.querySelector('[data-dedic-filtered-actions]')
const filteredClouds = document.querySelector('[data-filtered-clouds]')

const showAllBtn = document.querySelector('[data-dedic-show-all-tariffs]')

const tools = document.querySelector('[data-tools]')
const filterWrapper = document.querySelector('[data-filter-wrapper]')

const tariffAnchor = document.querySelector('[data-tariffs-anchor]')

const filterContainer = document.querySelector('[data-dedic-filter]')

const initialFilterState = { openedCategory: '', secondOpenedCategory: '' }

const filterStore = createStore(initialFilterState)

window.setFilerState = filterStore.setState
window.changeFilterHandler = changeFilterHandler

/**  --------- /FILTER INITIALIZING ---------  */

const responsePromise = fetchDedics(store)

i18next.on('loaded', () => {
  responsePromise
    .then(() => {
      if (container || mobileContainer) {
        const { desktopFragment, mobileFragment } = createDedicsMarkup(store)
        if (container) {
          renderMarkup(container, desktopFragment)
        }

        if (mobileContainer) {
          renderMarkup(mobileContainer, mobileFragment)
        }

        currencyStore.subscribe(() => {
          const { desktopFragment, mobileFragment } = createDedicsMarkup(store)

          if (container) {
            renderMarkup(container, desktopFragment)
          }

          if (mobileContainer) {
            renderMarkup(mobileContainer, mobileFragment)
          }
        })

        store.subscribe(() => {
          const { desktopFragment, mobileFragment } = createDedicsMarkup(store)

          if (container) {
            renderMarkup(container, desktopFragment)
          }

          if (mobileContainer) {
            renderMarkup(mobileContainer, mobileFragment)
          }
        })
      }
      if (filterContainer) {
        setFiltersData()
        openFilterBtns.forEach(btn => btn.removeAttribute('disabled'))
        store.subscribe(() => {
          renderFilters()
        })
        filterStore.subscribe(() => {
          renderFilters()
        })
      }
    })
    .catch(error => {
      console.error('Error fetching dedics:', error)
    })
})

openFilterBtns.forEach(btn =>
  btn.addEventListener('click', () => {
    filterContainer.parentElement.classList.toggle('show')
    document.body.classList.toggle('scroll-forbidden')
  }),
)

const getFiltersItems = () => {
  const items =
    store.getState().flist?.reduce((acc, el) => {
      const category = el.$.split(':')[0]

      acc[category] = [...(acc?.[category] || []), { ...el, available: true }]

      return acc
    }, {}) || {}

  sortCategoriesByQuantity(items.gen, items.ram, items.cpucores, items.drive, items.traffic)

  items.drive?.sort((a, b) => a.$.replace(/\d/g, '').localeCompare(b.$.replace(/\d/g, '')))
  return items
}

const sortCategoriesByQuantity = (...args) =>
  args.map(arg =>
    arg?.sort((a, b) => {
      if (a.$.toLowerCase().includes('unlimited')) {
        return 1
      }
      if (b.$.toLowerCase().includes('unlimited')) {
        return -1
      }
      return +a.$.replace(/\D/g, '') - +b.$.replace(/\D/g, '')
    }),
  )

function setFiltersData() {
  const state = store.getState()
  const { tariffs } = state
  const filtersItems = getFiltersItems()
  const set = new Set()
  store
    .getState()
    .flist?.filter(el => el.$.includes(':'))
    ?.forEach(el => {
      set.add(el.$.split(':')[0])
    })

  const filters = [...set].reduce((obj, el) => {
    obj[el] = []
    return obj
  }, {})

  if (window.location.search) {
    if (window.location.search.includes(CONFIG_CATEGORY)) {
      const values = window.location.search
        .slice(1)
        .split('&')
        .find(param => param.includes(CONFIG_CATEGORY))
        .split('=')[1]
        .split(',')

      const filteredTariffs = values
        .map(value => {
          const confName = decodeURI(value).toLowerCase()
          const tariffName = tariffs.find(
            tariff => tariff.configName.toLowerCase() === `config ${confName}`,
          )?.configName
          return tariffName
        })
        .filter(el => el)

      if (filteredTariffs.length) {
        showAllBtn.classList.remove('hidden')
        showAllBtn.addEventListener('click', function () {
          showAllBtn.classList.add('hidden')
          window.history.replaceState(null, '', window.location.pathname)

          store.setState({
            filteredTariffs: [],
          })
          scrollToTariffSection()
        })
      }

      store.setState({
        filtersItems,
        filters,
        filteredTariffs,
      })
      renderFilters()
      return
    }
    const filterByActivation = window.location.search.includes(QUICK_ACTIVATION_CATEGORY)
    let filterByPrice = false
    const dataFromURL = window.location.search
      ?.slice(1)
      .split('&')
      .reduce(
        (acc, el) => {
          const [key, value] = decodeURI(el).split('=')
          if (key === PRICE_CATEGORY) {
            filterByPrice = value.split(',')
          }

          const filtersValue = value
            .toLowerCase()
            .split(',')
            .map(el => {
              return filtersItems[key]?.find(item => item.$.toLowerCase() === `${key}:${el}`)
                ?.$key
            })
            .filter(el => el)

          filtersValue.length && acc.selectedCategories.push(key)
          acc.filters[key] = filtersValue
          return acc
        },
        { filters: {}, selectedCategories: [] },
      )

    if (!dataFromURL.selectedCategories.length) {
      if (filterByActivation || filterByPrice) {
        store.setState({
          filtersItems,
          filters,
          filterByPrice,
        })

        filterByActivation
          ? setTimeout(() => {
              changeFilterHandler(
                `${QUICK_ACTIVATION_CATEGORY}:true`,
                QUICK_ACTIVATION_CATEGORY,
                true,
              )
            }, 1)
          : setTimeout(() => {
              changeFilterHandler([filterByPrice[0], filterByPrice[1]], PRICE_CATEGORY, true)
            }, 1)
      } else {
        store.setState({
          filtersItems,
          filters,
        })
        renderFilters()
      }
      return
    }

    store.setState({
      filtersItems,
      selectedCategories: dataFromURL.selectedCategories,
      filters: { ...filters, ...dataFromURL.filters },
      filterByActivation,
      filterByPrice,
    })
    setTimeout(() => {
      changeFilterHandler(
        [
          ...dataFromURL.filters[[...dataFromURL.selectedCategories].reverse()[0]],
        ].reverse()[0],
        [...dataFromURL.selectedCategories].reverse()[0],
        true,
      )
    }, 1)
  } else {
    store.setState({
      filtersItems,
      filters,
    })

    renderFilters()
  }
}
let rangeValues = {}
let rangeLists

function renderFilters() {
  const {
    filtersItems,
    filters,
    selectedCategories,
    filterByActivation,
    filterByPrice,
    isFiltered,
    maxPrice,
  } = store.getState()
  const { openedCategory, secondOpenedCategory } = filterStore.getState()

  const renderCategory = new Set([
    ...FILTER_ORDER.map(el => el.name),
    ...Object.keys(filtersItems).filter(key => key !== 'soldout' && key !== 'gpu'),
  ])

  rangeLists = DEDIC_FILTER_RANGE_GROUPS.reduce((acc, key) => {
    acc[key] = filtersItems[key]?.map(el => el.$.replace(/\D/g, ''))
    return acc
  }, {})

  const filtersCategories = [...renderCategory].reduce((acc, category) => {
    const key =
      FILTER_ORDER.find(el => category.includes(el.name) && el.hasSubcategory)?.name ||
      category

    acc[key] = [
      ...new Set([
        ...(acc[key] || []),
        ...(FILTER_ORDER.find(el => el.name === key && el.hasSubcategory)?.subcategoryOrder ||
          []),
        category,
      ]),
    ]
    return acc
  }, {})

  const fragment = document.createDocumentFragment()
  const filterElem = document.createElement('div')
  filterElem.classList.add('filter')

  filterElem.innerHTML = `
    <div class="filter_fast">
      <ul class="filter__clouds">
      ${renderCloud({
        item: {
          $: `${QUICK_ACTIVATION_CATEGORY}:true`,
          $key: QUICK_ACTIVATION_CATEGORY,
          available: true,
        },
        isActive: filterByActivation,
      })}
        ${filtersCategories?.boolean
          ?.map(el => {
            if (!filtersItems[el] || el === 'booleanwithgpu') return null
            const item = filtersItems[el][0]
            const isActive = filters[el].includes(item.$key)

            return renderCloud({ item, isActive })
          })
          .join('')}
        </ul>
    </div>


     <div class="filter_groups">
     <div>
        <label>${t('price_per_month')}</label>
        <div class="price_fields">
          <div class="price_filed_wrapper"> 
            <input class="price_field" data-price-min type="number" />
          </div>
            -
          <div class="price_filed_wrapper">
            <input class="price_field" data-price-max type="number" />
          </div>
        </div>
        <div data-range="${PRICE_CATEGORY}"></div>
     </div>
        ${[...renderCategory]
          ?.map(category => {
            const isOpened = openedCategory === category

            const categoryItems = filtersCategories[category]?.reduce(
              (acc, el) => {
                acc.count += DEDIC_FILTER_RANGE_GROUPS.includes(el)
                  ? Number(!!filters[el]?.length)
                  : filters[el]?.length || 0

                acc.isAvailable =
                  acc.isAvailable || filtersItems[el]?.some(filter => filter.available)

                return acc
              },
              { count: 0, isAvailable: false },
            )

            return `
            ${
              filtersCategories[category] && category !== 'boolean'
                ? `
                <div class="filter__btn_wrapper">
                  <button
                    class="filter__btn filter__group_btn ${isOpened ? 'opened' : ''} "
                    onclick="setFilerState({openedCategory: ${
                      isOpened ? false : `'${category}'`
                    }})"
                    type="button"
                    ${!categoryItems.isAvailable ? 'disabled' : ''}
                  >
                    <span class="filter__label">${t(category)}</span>

                    ${
                      categoryItems.count
                        ? `
                      <span class="filter_amount">${categoryItems.count}</span>`
                        : ''
                    }
                   ${shevronIcon}
                  </button>

            
                 <div class="filter__group_options ${isOpened ? 'opened' : ''} ">
         
                  ${filtersCategories[category]
                    ?.filter(group => filtersItems[group])
                    .map((group, _, arr) => {
                      const isSecondOpened = secondOpenedCategory === group || arr.length === 1
                      const subcategoryItemsCount = DEDIC_FILTER_RANGE_GROUPS.includes(group)
                        ? Number(!!filters[group]?.length)
                        : filters[group]?.length

                      return `
                        <div class="filter__group_options_wrapper">
                          ${
                            arr.length > 1
                              ? ` <button
                              class="filter__btn ${isSecondOpened ? 'opened' : ''}"
                              onclick="setFilerState({secondOpenedCategory: ${
                                isSecondOpened ? false : `'${group}'`
                              }})"
                              type="button"
                              ${!categoryItems.isAvailable ? 'disabled' : ''}
                            >
                              <span class="filter__label">${t(`subcategory.${group}`)}</span>
                              ${
                                subcategoryItemsCount
                                  ? `
                                <span class="filter_amount">${subcategoryItemsCount}</span>
                              `
                                  : ''
                              }
                                  ${shevronIcon}
                            </button>`
                              : ''
                          }
                          <div
                            class="filter__option_wrapper ${isSecondOpened ? 'opened' : ''}" 
                          >
                            ${
                              DEDIC_FILTER_RANGE_GROUPS.includes(group)
                                ? `
                               
                                  <div data-range="${group}"></div>
                          
                              `
                                : [...(filtersItems?.[group] || [])]
                                    ?.sort((a, b) => b.available - a.available)
                                    .map(item => {
                                      const optionName = item?.$.split(':')[1]
                                      return `
                                      <label class="filter__option ${
                                        filters?.[group]?.includes(item?.$key) ? 'active' : ''
                                      } ${!item.available ? 'disabled' : ''}"
                                       data-group="${group}"
                                       data-name="${optionName.toLowerCase()}"
                                       >
                                      <input 
                                      type="checkbox"
                                      onclick="changeFilterHandler('${item.$key}', '${group}')"
                                       ${!item.available ? 'disabled' : ''}
                                      />
                                      <span class="checkbox"></span>
                                        <span
                                          class="filter__option_name" 
                                        >
                                          ${t(optionName)}
                                        </span>
                                      </label>
                                      `
                                    })
                                    .join('')
                            }
                          </div>
                        </div>
                      `
                    })
                    .join('')}
                </div>
                `
                : ''
            }
            </div>
            `
          })
          .join('')}
      </div>
  `

  fragment.append(filterElem)
  filterContainer.innerHTML = ''
  filterContainer.append(fragment)

  const minPriceField = filterContainer.querySelector('[data-price-min]')
  const maxPriceField = filterContainer.querySelector('[data-price-max]')

  const ranges = filterContainer.querySelectorAll('[data-range]')
  if (ranges.length) {
    ranges.forEach(range => {
      const rangeGroup = range.getAttribute('data-range')

      const isPriceValue = rangeGroup === PRICE_CATEGORY

      let maxValue
      let minValue

      if (
        !rangeValues[rangeGroup] &&
        window.location.search &&
        window.location.search.includes(`${rangeGroup}=`)
      ) {
        const urlRangeValues = window.location.search
          .slice(1)
          ?.split('&')
          ?.find(el => el.includes(`${rangeGroup}=`))
          ?.split('=')?.[1]
          .split(',')

        const min = Math.min(...urlRangeValues)
        const max = Math.max(...urlRangeValues)

        minValue = isPriceValue
          ? min
          : rangeLists[rangeGroup].findIndex(el => el === min.toString())

        maxValue = isPriceValue
          ? max
          : rangeLists[rangeGroup].findIndex(el => el === max.toString())
      }

      const value =
        rangeValues[rangeGroup] ||
        (minValue !== undefined && [minValue, maxValue]) ||
        (isPriceValue ? [0, maxPrice] : [0, rangeLists[rangeGroup]?.length - 1])

      !rangeValues[rangeGroup] && (rangeValues[rangeGroup] = value)

      const rangeMaxValue = isPriceValue ? maxPrice : rangeLists[rangeGroup]?.length - 1

      const rangrElement = rangeSlider(range, {
        min: 0,
        max: rangeMaxValue,
        rangeSlideDisabled: true,
        value,
        onInput: (value, isRangeTarget) => {
          setRangeLabelValue(value, rangeLists, rangeGroup)
          rangeValues = { ...rangeValues, [rangeGroup]: value }
          if (isPriceValue && isRangeTarget) {
            minPriceField.value = value[0]
            maxPriceField.value = value[1]
          }
        },

        onThumbDragEnd: () => {
          changeFilterHandler(
            [rangeValues[rangeGroup]?.[0], rangeValues[rangeGroup]?.[1]],
            rangeGroup,
          )
        },
      })

      if (isPriceValue) {
        minPriceField.value = value[0]
        maxPriceField.value = value[1]

        minPriceField.addEventListener('input', function (e) {
          const targetValue = +e.target.value

          e.target.value = targetValue
          rangrElement.value([targetValue, value[1]])
        })

        maxPriceField.addEventListener('input', function (e) {
          const targetValue = +e.target.value
          e.target.value = targetValue
          rangrElement.value([value[0], targetValue])
        })

        minPriceField.addEventListener('blur', function (e) {
          const targetValue = +e.target.value
          if (targetValue === value[0]) return
          const values =
            targetValue > value[1] ? [value[1], targetValue] : [targetValue, value[1]]

          if (values[1] > maxPrice) {
            values[1] = maxPrice
          }
          if (values[0] < 0) {
            values[0] = 0
          }
          rangeValues[rangeGroup] = values

          changeFilterHandler(values, rangeGroup)
        })
        maxPriceField.addEventListener('blur', function (e) {
          const targetValue = +e.target.value
          if (targetValue === value[1]) return
          const values =
            targetValue < value[0] ? [targetValue, value[0]] : [value[0], targetValue]

          if (values[1] > maxPrice) {
            values[1] = maxPrice
          }
          if (values[0] < 0) {
            values[0] = 0
          }

          rangeValues[rangeGroup] = values
          changeFilterHandler(values, rangeGroup)
        })
      }

      setRangeLabelValue([], rangeLists, rangeGroup)
    })
  }

  if (isFiltered) {
    filteredActions.classList.add('show')

    filteredClouds.innerHTML = `
    ${
      filterByPrice
        ? renderCloud({
            item: {
              $: `${PRICE_CATEGORY}`,
              $key: [0, maxPrice],
              available: true,
            },
            crossIcon: true,
          })
        : ''
    }
    ${
      filterByActivation
        ? renderCloud({
            item: {
              $: `${QUICK_ACTIVATION_CATEGORY}:true`,
              $key: QUICK_ACTIVATION_CATEGORY,
              available: true,
            },
            crossIcon: true,
          })
        : ''
    }
    ${selectedCategories
      .map(key => {
        if (!filters[key].length) return null

        if (DEDIC_FILTER_RANGE_GROUPS.includes(key)) {
          return renderCloud({
            item: { $: key, $key: [0, rangeLists[key]?.length - 1], available: true },
            crossIcon: true,
          })
        }

        return filtersItems[key]
          .filter(el => filters[key].includes(el.$key))
          .map(item => {
            const withValue = !item.$.includes('boolean')
            return renderCloud({ item, withValue, crossIcon: true })
          })
          .join('')
      })
      .join('')}
    `
  } else {
    filteredActions.classList.remove('show')
    filteredClouds.innerHTML = ''
  }

  setStickyPositions()
}

function renderCloud({ item, isActive, withValue, crossIcon }) {
  const [label, value] = item.$.split(':')

  return `<li>
            <button
              class="filter__cloud ${isActive ? 'active' : ''}"
              type="button"
              onclick="changeFilterHandler('${item.$key}', '${label}')"
              ${!item.available ? 'disabled' : ''}
            >
            <span class="filter__cloud_value">${
              isTranslationExists(`subcategory.${label}`)
                ? t(`subcategory.${label}`)
                : t(label)
            }${withValue ? ':' : ''}</span>
            ${withValue ? `<span class="filter__cloud_name">${t(value)}</span>` : ''}
            ${
              crossIcon
                ? `<svg xmlns="http://www.w3.org/2000/svg" class="close_icon" viewBox="0 0 24 24" width="24" height="24" fill="none">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 7 7 17M7 7l10 10"/>
                  </svg>`
                : ''
            }
            </button>
          </li>`
}

function setSelectedCategoriesToParams(searchParams) {
  const state = store.getState()
  const { selectedCategories, filters, filtersItems } = state
  selectedCategories.forEach(category => {
    const values = filters[category].map(filterItem => {
      return filtersItems[category].find(item => item.$key === filterItem)?.$.split(':')?.[1]
    })

    searchParams.setEncodeValue(category, values.join(','))
  })
}

function changeFilterHandler(value, category, addFromURL) {
  const state = store.getState()
  const {
    filtersItems,
    filters,
    selectedCategories,
    tariffs,
    filterByActivation,
    maxPrice,
    filterByPrice,
  } = state

  if (!showAllBtn.classList.contains('hidden')) {
    showAllBtn.classList.add('hidden')
  }

  const searchParams = new URLSearchParams()
  searchParams.setEncodeValue = (key, value) => searchParams.set(key, encodeURI(value))

  if (category === PRICE_CATEGORY) {
    if (typeof value === 'string') {
      value = value.split(',').map(el => +el)
      rangeValues[category] = value
    }

    const isFilteredByPrice = value[0] !== 0 || value[1] !== maxPrice

    isFilteredByPrice
      ? searchParams.setEncodeValue(PRICE_CATEGORY, value.join(','))
      : searchParams.delete(PRICE_CATEGORY)

    filterByActivation && searchParams.setEncodeValue(QUICK_ACTIVATION_CATEGORY, true)

    setSelectedCategoriesToParams(searchParams)

    const isFiltered = checkIfFiltered(filters, filterByActivation, isFilteredByPrice)

    store.setState({
      filterByPrice: isFilteredByPrice && value,
      isFiltered,
    })

    changeWindowParams(searchParams, addFromURL)
    return
  }

  if (category === QUICK_ACTIVATION_CATEGORY) {
    filterByPrice && searchParams.setEncodeValue(PRICE_CATEGORY, filterByPrice.join(','))

    !filterByActivation
      ? searchParams.setEncodeValue(QUICK_ACTIVATION_CATEGORY, true)
      : searchParams.delete(QUICK_ACTIVATION_CATEGORY)

    setSelectedCategoriesToParams(searchParams)

    const isFiltered = checkIfFiltered(filters, !filterByActivation, filterByPrice)

    store.setState({
      filterByActivation: !filterByActivation,
      isFiltered,
    })

    changeWindowParams(searchParams, addFromURL)
    return
  }

  filterByPrice && searchParams.setEncodeValue(PRICE_CATEGORY, filterByPrice.join(','))
  filterByActivation && searchParams.setEncodeValue(QUICK_ACTIVATION_CATEGORY, true)

  const copyFiltersItems = JSON.parse(JSON.stringify(filtersItems))
  const isRangeCategory = DEDIC_FILTER_RANGE_GROUPS.includes(category)

  let copyFilters = JSON.parse(JSON.stringify(filters))

  let isAdding = true
  if (!addFromURL) {
    if (isRangeCategory) {
      if (typeof value === 'string') {
        value = value.split(',').map(el => +el)
        rangeValues[category] = value
      }
      if (value[0] === 0 && value[1] === copyFiltersItems[category].length - 1) {
        copyFilters = {
          ...copyFilters,
          [category]: [],
        }
        isAdding = false
      } else {
        const filterValues = copyFiltersItems[category]
          .filter((_, i) => {
            return i >= value[0] && i <= value[1]
          })
          .map(el => el.$key)

        copyFilters = {
          ...copyFilters,
          [category]: [...filterValues],
        }
      }
    } else if (filters?.[category]?.includes(value)) {
      copyFilters = {
        ...copyFilters,
        [category]: copyFilters[category].filter(el => el !== value),
      }
      isAdding = false
    } else {
      copyFilters = {
        ...copyFilters,
        [category]: [...copyFilters[category], value],
      }
    }
  }

  let categories = isAdding
    ? selectedCategories.includes(category)
      ? selectedCategories
      : [...selectedCategories, category]
    : copyFilters[category].length
    ? selectedCategories
    : selectedCategories.filter(el => el !== category)

  const categoriesKeys = [...new Set([...categories, ...Object.keys(copyFilters)])]

  const allowedFilters = categoriesKeys.reduce((acc, key, index) => {
    acc[key] = tariffs?.filter(tariff => {
      if (DEDIC_FILTER_RANGE_GROUPS.includes(key)) return true
      const filterList = tariff?.tags
      let hasFilter = true

      for (let i = 0; i < index; i++) {
        hasFilter = checkIfHasFilter(copyFilters, categoriesKeys[i], filterList)

        if (!hasFilter) break
      }

      return hasFilter
    })

    copyFilters[key] = copyFilters[key].filter(el => JSON.stringify(acc[key]).includes(el))
    if (!copyFilters[key].length) {
      categories = categories.filter(el => el !== key)
    }

    return acc
  }, {})

  for (const key in copyFiltersItems) {
    copyFiltersItems[key] = copyFiltersItems[key].map(el => ({
      ...el,
      available: JSON.stringify(allowedFilters[key]).includes(el.$key),
    }))
  }

  const filteredTariffList = tariffs?.filter(el => {
    const filterList = el?.tags
    let hasFilter

    for (const key in copyFilters) {
      hasFilter = checkIfHasFilter(copyFilters, key, filterList)

      if (!hasFilter) break
    }

    return hasFilter
  })

  categories.forEach(category => {
    const values = copyFilters[category].map(filterItem => {
      return copyFiltersItems[category]
        .find(item => item.$key === filterItem)
        ?.$.split(':')?.[1]
    })
    searchParams.setEncodeValue(category, values.join(','))
  })

  const isFiltered = checkIfFiltered(copyFilters, filterByActivation, filterByPrice)

  store.setState({
    filters: copyFilters,
    filtersItems: copyFiltersItems,
    filteredTariffs: filteredTariffList.map(el => el.configName),
    selectedCategories: categories,
    isFiltered,
  })

  changeWindowParams(searchParams, addFromURL)
}

function checkIfHasFilter(filters, key, filterList) {
  return filters[key].length
    ? filterList.some(filterItem => filters[key].includes(filterItem.$key))
    : true
}

function setRangeLabelValue([min, max] = [], rangeLists, rangeGroup) {
  if (rangeGroup === PRICE_CATEGORY) {
    return true
  }
  const minThumb = document.querySelector(`[data-range='${rangeGroup}'] [data-lower]`)
  const maxThumb = document.querySelector(`[data-range='${rangeGroup}'] [data-upper]`)

  const minValue = min ?? minThumb?.getAttribute('aria-valuenow')
  const maxValue = max ?? maxThumb?.getAttribute('aria-valuenow')

  minThumb?.setAttribute('aria-displayvalue', rangeLists[rangeGroup][minValue])
  maxThumb?.setAttribute('aria-displayvalue', rangeLists[rangeGroup][maxValue])
}

clearFilterBtn?.addEventListener('click', clearFilter)

function clearFilter() {
  const { maxPrice } = store.getState()

  Object.keys(rangeValues).forEach(group => {
    if (group === PRICE_CATEGORY) {
      rangeValues[group] = [0, maxPrice]
    } else {
      rangeValues[group] = [0, rangeLists[group]?.length - 1]
    }
  })

  store.setState({
    selectedCategories: [],
    filtersItems: getFiltersItems(),
    filters: Object.keys(store.getState().filters).reduce((obj, el) => {
      obj[el] = []
      return obj
    }, {}),
    filteredTariffs: [],
    filterByActivation: false,
    isFiltered: false,
    filterByPrice: false,
  })

  changeWindowParams()
}

function setToolsBackdrop() {
  const toolsTop = tools.getBoundingClientRect().top
  const headerHeight = header.clientHeight

  if (toolsTop < headerHeight + 5) {
    tools.classList.add('backdrop')
  } else {
    tools.classList.remove('backdrop')
  }
}
setToolsBackdrop()
window.addEventListener('scroll', setToolsBackdrop)

function setStickyPositions() {
  if (window.innerWidth > 1439) {
    const headerHeight = header.clientHeight

    const isToolsVisible =
      filteredActions.classList.contains('show') || !showAllBtn.classList.contains('hidden')

    tools.dataset.visible = isToolsVisible
    tools.style.top = isToolsVisible ? headerHeight + 'px' : ''

    const toolsHeight = isToolsVisible ? tools.clientHeight : 0
    const filterWrapperTop = headerHeight + toolsHeight + 10

    filterWrapper.style.top = filterWrapperTop + 'px'
    filterContainer.style.maxHeight = window.innerHeight - filterWrapperTop - 10 + 'px'

    return isToolsVisible
  }
}

function scrollToTariffSection(addFromURL) {
  const isToolsVisible = setStickyPositions()
  if (!addFromURL && window.innerWidth > 1439) {
    const headerHeight = header.clientHeight
    tariffAnchor.style.top = isToolsVisible
      ? `-${headerHeight}px`
      : `-${headerHeight - tools.clientHeight}px`
    tariffAnchor.scrollIntoView()
  }
}

function setNewUrl(searchParams) {
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${
      searchParams?.toString().length ? `?${decodeURIComponent(searchParams.toString())}` : ''
    }  `,
  )
}

function changeWindowParams(searchParams, addFromURL) {
  setNewUrl(searchParams)
  scrollToTariffSection(addFromURL)
}

function checkIfFiltered(filters, filterByActivation, filterByPrice) {
  return (
    Object.keys(filters).some(key => filters[key].length) ||
    filterByActivation ||
    filterByPrice
  )
}
